<template>
  <div class="box">
    <div class="header container">
      <div class="logo">
        <img src="../../assets/images/logo.png" alt="logo" style="cursor:pointer;" />
      </div>
      <div>
        <ul class="header_ul nav nav-pills" id="menu_bar">
          <li role="presentation" class="current">
            <a href="/" style="color:#337be9;">首页</a>
          </li>
          <li role="presentation">
            <a href="#process">赚钱流程</a>
          </li>
          <li role="presentation">
            <a href="#advantage">坤玛优势</a>
          </li>
          <li role="presentation">
            <a href="#case">成功案例</a>
          </li>
          <li role="presentation">
            <a href="#about_us">关于我们</a>
          </li>
        </ul>
        <div class="bodyDiv" id="bodyDiv">
          <div class="current">我是体育模块</div>
          <div>我是娱乐模块</div>
          <div>我是新闻模块</div>
          <div>我是综合模块</div>
        </div>
      </div>
    </div>
    <div id="demo" class="carousel slide nomargin" data-ride="carousel">
      <!-- 指示符 -->
      <!-- <ul class="carousel-indicators">
        <li data-target="#demo" data-slide-to="0" class="active"></li>
        <li data-target="#demo" data-slide-to="1"></li>
        <li data-target="#demo" data-slide-to="2"></li>
      </ul>-->
      <!-- 轮播图片 -->
      <div class="carousel-inner">
        <div class="carousel-item active" role="listbox">
          <img src="../../assets/images/banner.png" alt="轮播图" style="cursor:pointer;" />
        </div>
        <!-- <div class="carousel-item">
          <img src="../../assets/images/banner.png">
        </div>
        <div class="carousel-item">
          <img src="../../assets/images/banner.png">
        </div>-->
      </div>
      <!-- 左右切换按钮 -->
      <!-- <a class="carousel-control-prev" href="#demo" data-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </a>
      <a class="carousel-control-next" href="#demo" data-slide="next">
        <span class="carousel-control-next-icon"></span>
      </a>-->
    </div>
    <div class="broker container" id="about_us">
      <div class="broker_title">关于坤玛产品经纪人</div>
      <div class="broker_img">
        <img class="img" src="../../assets/images/broker1.png" alt="经纪人佣金" />
        <img class="img" src="../../assets/images/broker2.png" alt="经纪人时间" />
        <img class="img" src="../../assets/images/broker3.png" alt="经纪人投入" />
      </div>
    </div>
    <div class="story">
      <div class="container">
        <div class="broker_title" id="case">产品经纪人故事</div>
        <div class="story_img">
          <img class="img" src="../../assets/images/story2.png" alt="经纪人故事" />
          <img class="img" src="../../assets/images/story3.png" alt="经纪人故事" />
          <img class="img" src="../../assets/images/story1.png" alt="经纪人故事" />
        </div>
      </div>
    </div>
    <!-- 如何成为经纪人 -->
    <div class="what_broker container" id="process">
      <div class="what_broker_title">如何成为产品经纪人</div>
      <div class="what_img">
        <img class="img" src="../../assets/images/what1.png" alt="如何成为经纪人" />
        <img class="img" src="../../assets/images/what2.png" alt="如何成为经纪人" />
        <img class="img" src="../../assets/images/what3.png" alt="如何成为经纪人" />
      </div>
    </div>
    <!-- 需要做什么 -->
    <div class="what_need">
      <div class="container">
        <div class="what_need_title">产品经纪人需要做什么</div>
        <div class="what_need_img">
          <img class="what_need1" src="../../assets/images/what_need1.png" alt="产品经纪人需要做什么" />
          <img class="what_need2 img" src="../../assets/images/what_need2.png" alt="产品经纪人需要做什么" />
        </div>
      </div>
    </div>
    <!-- 优势 -->
    <div class="advantage" id="advantage">
      <div class="advantage_title">成为产品经纪人的优势</div>
      <div class="advantage_item">
        <div class="advantage_item_title">资源与支持</div>
        <div class="advantage_item_img">
          <img class="img" src="../../assets/images/advantage1.png" alt="经纪人的优势" />
          <img class="img" src="../../assets/images/advantage2.png" alt="经纪人的优势" />
          <img class="img" src="../../assets/images/advantage3.png" alt="经纪人的优势" />
          <img class="img" src="../../assets/images/advantage4.png" alt="经纪人的优势" />
        </div>
      </div>
      <div class="line"></div>
      <div class="advantage_item">
        <div class="advantage_item_title2">交易保证</div>
        <div class="pledge">
          <div class="pledge_item">
            <img src="../../assets/images/pledge1.png" alt />
            <div class="pledge_item_txt">全新包装</div>
          </div>
          <div class="pledge_item">
            <img src="../../assets/images/pledge2.png" alt />
            <div class="pledge_item_txt">一年质保</div>
          </div>
          <div class="pledge_item">
            <img src="../../assets/images/pledge3.png" alt />
            <div class="pledge_item_txt">佣金速结</div>
          </div>
          <div class="pledge_item">
            <img src="../../assets/images/pledge4.png" alt />
            <div class="pledge_item_txt">专业团队</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="brand_title">合作品牌</div>
      <div class="brand_img">
        <img src="../../assets/images/brand.png" alt="合作品牌" />
      </div>
      <div class="footer_logo">
        <img src="../../assets/images/footer_logo.png" alt="logo" style="cursor:pointer;" />
      </div>
      <div class="copyright">
        <div class="copyright_txt">
          Copyright &copy; 2009 广东坤玛机电有限公司 All Rights Reserved 沪ICP备08111853号
          <a
            href="https://beian.miit.gov.cn"
          >备案查询网址：https://beian.miit.gov.cn</a>
        </div>
      </div>
    </div>
    <!-- <footer-nav /> -->
    <img class="go_top" id="gotoTop" @click="backtop" src="../../assets/images/top.png" alt="返回首页" style="cursor: pointer;" />
  </div>
</template>

<script>
import FooterNav from '@/components/footer'
export default {
  components: {
    FooterNav
  },
  mounted () {
    window.addEventListener('scroll', this.showbtn, true)
    // 导航栏 选中
    var menuBar = document.querySelector('#menu_bar')
    var menuLi = menuBar.getElementsByTagName('li')
    for (var i = 0; i < menuLi.length; i++) {
      var li = menuLi[i]
      li.setAttribute('index', i)
      li.onmouseover = fn
      li.onmouseout = fn2
    }
    function fn () {
      for (var i = 0; i < menuLi.length; i++) {
        var li = menuLi[i]
        li.className = ''
      }
      this.className = 'current'
      // 下拉内容
      // var bodyDiv = document.querySelector('#bodyDiv')
      // var divs = bodyDiv.getElementsByTagName('div')
      // for (let i = 0; i < divs.length; i++) {
      //   var div = divs[i]
      //   div.className = ''
      // }
      // var index = this.getAttribute('index')
      // divs[index].className = 'current'
    }
    function fn2 () {
      for (var i = 0; i < menuLi.length; i++) {
        var li = menuLi[i]
        li.className = ''
        // eslint-disable-next-line eqeqeq
        if (menuLi[i] == 0) {
          this.className = 'current'
        }
      }
    }
  },
  methods: {
    // 显示回到顶部按钮
    showbtn () {
      let that = this
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      that.scrollTop = scrollTop
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop () {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    }
  }
}
</script>

<style scoped>
.box {
  width: 100%;
  height: 100%;
  background: #fff;
  min-width: 320px;
  overflow-x: hidden;
}
a {
  text-decoration: none;
  color: #000;
}
/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  color: #337be9;
  text-decoration: none;
}
/* 正在点击的链接*/
a:active {
  color: #337be9;
  text-decoration: none;
}
.nomargin {
  margin: 0;
}
.header {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: space-between;
  height: 109px;
  line-height: 109px;
}
.logo img {
  width: 164px;
  height: 47px;
}
.header_ul li {
  float: left;
  padding: 0 15px;
}
.current {
  color: #337be9;
  /* border-bottom: 3px solid #337be9; */
  padding: 0 15px;
  height: 39px;
  line-height: 39px;
  margin-top: 35px;
}
.bodyDiv div {
  height: 255px;
  background-color: purple;
  display: none;
  z-index: 999;
  border: 1px solid #f00;
}
/* .bodyDiv div.current {
  display: block;
} */
.carousel-item img {
  width: 100%;
  height: auto;
  background-size: cover;
}
/* 经纪人 */
.broker {
  text-align: center;
  height: auto;
}
.broker_title {
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  height: 200px;
  line-height: 200px;
}
.broker_img img {
  width: 318px;
  height: 488px;
  margin-bottom: 96px;
}
/* 故事 */
.story {
  width: 100%;
  height: auto;
  text-align: center;
  background: #f5f5f5;
}
.story_img img {
  width: 348px;
  height: 646px;
  margin-bottom: 71px;
}
/* 如何成为 */
.what_broker {
  width: 100%;
  height: auto;
  text-align: center;
}
.what_broker_title {
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  height: 174px;
  line-height: 174px;
}
.what_img img {
  width: 356px;
  height: 642px;
  margin-bottom: 77px;
}
/* 需要做什么 */
.what_need {
  width: 100%;
  height: auto;
  text-align: center;
  background: url(../../assets/images/what_bg.png) no-repeat;
  background-size: 100% 100%;
  background: #4c87e8;
}
.what_need_title {
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  height: 172px;
  line-height: 172px;
}
.what_need1 {
  width: 700px;
  height: 500px;
  margin-right: 30px;
}
.what_need2 {
  width: 320px;
  height: 590px;
  margin-bottom: 76px;
}
/* 优势 */
.advantage {
  width: 100%;
  height: auto;
  text-align: center;
}
.advantage_title {
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  height: 204px;
  line-height: 204px;
}
.advantage_item_title {
  font-size: 64px;
  font-family: Source Han Sans CN;
  font-weight: 800;
  color: rgba(253, 69, 50, 1);
}
.advantage_item_img {
  margin-top: 30px;
  margin-bottom: 102px;
}
.advantage_item_img img {
  width: 270px;
  height: 420px;
}
.line {
  width: 1060px;
  height: 2px;
  margin: auto;
  border: 1px dashed #ccc;
}
.advantage_item_title2 {
  height: 240px;
  line-height: 240px;
  font-size: 64px;
  font-family: Source Han Sans CN;
  font-weight: 800;
  color: rgba(253, 69, 50, 1);
}
.pledge {
  display: flex;
  flex-wrap: nowrap;
  width: 850px;
  margin: auto;
}
.pledge_item {
  width: 25%;
}
.pledge_item img {
  width: 140px;
  height: 160px;
}
.pledge_item_txt {
  font-size: 42px;
  font-family: "SourceHanSansCN-Bold";
  font-weight: bold;
  color: #666;
  margin-bottom: 133px;
}
.footer {
  width: 100%;
  height: 970px;
  text-align: center;
  background: url(../../assets/images/what_bg.png) no-repeat;
  background-size: 100% 100%;
  background: #4c87e8;
}
.brand_title {
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  height: 190px;
  line-height: 210px;
}
.brand_img img {
  width: 100%;
  height: auto;
  padding: 0;
  margin: 0;
}
.footer_logo img {
  width: 90px;
  height: 76px;
  margin-top: 87px;
  margin-bottom: 36px;
}
.copyright {
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  opacity: 0.4;
  display: flex;
  flex-wrap: nowrap;
}
.copyright_txt {
  width: 100%;
  text-align: center;
}
.copyright_txt a {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-left: 10px;
}
.copyright_txt a:hover {
  color: #00f;
  text-decoration: underline;
}
/* 回到顶部 */
.go_top {
  position: fixed;
  right: 50px;
  bottom: 50px;
  width: 54px;
  height: 54px;
}

.img {
  transition: All 0.4s ease-in-out;
  -webkit-transition: All 0.4s ease-in-out;
  -moz-transition: All 0.4s ease-in-out;
  -o-transition: All 0.4s ease-in-out;
}
.img:hover {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
  -ms-transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue